/**
 * @file main.js
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/main';
import VeeValidate from 'vee-validate';
import {config} from './plugins/validator-plugin';
import BrowserDecorator from './plugins/browser/browserDecorator';
import {filterPlugin} from './plugins/filter-plugin';
import VueDOMPurifyHTML from 'vue-dompurify-html';
// 动态生成meta
import MetaInfo from 'vue-meta-info';
import {DatePicker, Pagination, Dialog, Carousel, CarouselItem, Loading, Tag, Button, Input} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

VueClipboard.config.autoSetContainer = true;
// 一般插件都要use
Vue.use(VueClipboard);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(MetaInfo);
Vue.use(BrowserDecorator);
Vue.use(filterPlugin);
Vue.use(VeeValidate, config);
Vue.use(preview);
Vue.use(Loading);
Vue.use(Tag);
Vue.use(Button);
Vue.use(Input);
Vue.use(VueDOMPurifyHTML);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
